module.exports = __webpack_public_path__ + "img/notebook.6f311b86.gif";